/**
 * @file Web galleries album custom print checkout view.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Link, withRouter } from 'react-router-dom';
import compose from 'lodash.flowright';

import WebGalleryHeaderContainer from '../containers/WebGalleryHeaderContainer';
import WebGalleriesCustomPrintCheckoutContainer from '../containers/WebGalleriesCustomPrintCheckoutContainer';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      albumId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

const WebGalleriesAlbumCustomPrintCheckoutView = ({ match }) => {
  const { albumId } = match.params;
  return (
    <Fragment>
      <Helmet>
        <title>Get your prints! &ndash; Waldo Photos</title>
      </Helmet>

      <WebGalleryHeaderContainer />

      <div className="toolbar sticky-top">
        <span className="mx-auto toolbar-title toolbar-title-fullwidth text-base">
          <Link to={`/galleries/view/album/${albumId}`}>
            &larr; Back to the Gallery
          </Link>
        </span>
      </div>

      <div className="flex-auto content-wrap-gray">
        <div className="custom-prints-view-wrap">
          <WebGalleriesCustomPrintCheckoutContainer />
        </div>
      </div>
    </Fragment>
  );
};

WebGalleriesAlbumCustomPrintCheckoutView.propTypes = propTypes;

export default compose(withRouter)(WebGalleriesAlbumCustomPrintCheckoutView);
